import { Button } from "@/components/ui/button";
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "@/components/ui/command";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { useSocket } from "@/hooks/use-socket";
import { useToast } from "@/hooks/use-toast";
import { tfaAtom } from "@/lib/atoms";
import { getCompanyToken, getSiteToken, useApi } from "@/lib/pariette";
import { cn } from "@/lib/utils";
import { useSetAtom } from "jotai";
import { Check, ChevronDown } from "lucide-react";
import { useTranslations } from "next-intl";
import React, { useEffect, useState } from "react";

interface DialogProps {
  titleAndText?: { title?: string; text?: string };
  open: any;
  no: () => void;
  yes: (props?: any) => void;
}

const CreateUser: React.FC<DialogProps> = ({ open, no, yes }) => {
  const [rulesData, setRulesData] = useState<any>({
    operation: "create",
  });
  const setIs2faModal = useSetAtom(tfaAtom);
  const { $get } = useApi();
  const { checkRules } = useSocket();
  const t = useTranslations("general");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [authGrops, setAuthGroups] = useState<{ title: string }[]>([]);
  const [auth, setAuth] = useState<{ title: string } | null>(null);
  const new_user = {
    auth_group: null,
    name: "",
    email: "",
    boss: 0,
    opus: 0,
    employe: 1,
    user: 1,
    phone: "",
    level: 207,
  };
  const { toast } = useToast();

  const fetchGroup = async () => {
    await $get("auth-group").then((res) => {
      setAuthGroups(res.data);
    });
  };

  useEffect(() => {
    if (open) {
      fetchGroup();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  //   const handleClose = () => {
  //     setOpenD(false);
  //   };

  const createUser = async () => {
    if (name.length > 3 && phone.length > 9 && phone.length < 17 && email.length > 5 && email.includes("@") && email.includes(".") && email.length < 65 && auth?.title) {
      setIs2faModal(true);

      const randomPass = Math.random().toString(36).substr(2);
      const newUser = {
        company: getCompanyToken(),
        site: getSiteToken(),
        store: false,
        type: 102,
        auth_group: auth?.title,
        opus: new_user.opus,
        boss: 0,
        employe: 1,
        user: new_user.user,
        username: "",
        name: name,
        surname: "",
        email: email,
        password: randomPass,
        c_password: randomPass,
        login_method: "",
        phone: phone,
        gender: "",
        level: new_user.level,
        photo: "",
        kvkk: 1,
        status: 1,
        representative: auth.title === "representative" ? 1 : 0,
      };
      checkRules(
        rulesData,
        ["User creation process."],
        {
          api: "auth/register",
          data: newUser,
        },
        (response: any) => afterCheck(response)
      );
    } else {
      toast({
        variant: "destructive",
        description: t("fillError"),
      });
    }
  };

  const afterCheck = async (response: any) => {
    //socket kontrolü sonra yapılacak işlemler
    setIs2faModal(false);
    if (response.status) {
      setAuth(null);
      setName("");
      setEmail("");
      setPhone("");
      yes(response);
    } else {
      //
    }
  };

  return (
    <>
      <Dialog
        open={open}
        onOpenChange={(o) => {
          if (!o) {
            no();
          }
        }}
      >
        <DialogContent className="overflow-visible">
          <DialogHeader>
            <DialogTitle>{t("newUser")}</DialogTitle>
          </DialogHeader>
          <div>
            <Label htmlFor="name">{t("name")}</Label>
            <Input id="name" type="text" onChange={(e) => setName(e.target.value)} />
          </div>
          <div>
            <Label htmlFor="email">{t("email")}</Label>
            <Input id="email" type="email" onChange={(e) => setEmail(e.target.value)} />
          </div>

          <Popover>
            <PopoverTrigger asChild>
              <Button variant="outline" role="combobox" className="w-[200px] justify-between">
                {auth?.title ?? t("authentication")}
                <ChevronDown className="opacity-50" />
              </Button>
            </PopoverTrigger>
            <PopoverContent className="w-[400px] p-0">
              <Command>
                <CommandInput className="h-9" />
                <CommandList>
                  <CommandEmpty>Nicht gefunden</CommandEmpty>
                  <CommandGroup>
                    {authGrops.map((lookup) => (
                      <CommandItem
                        key={lookup.title}
                        value={lookup.title.toString()}
                        onSelect={() => {
                          setAuth(lookup);
                        }}
                      >
                        {lookup.title}
                        <Check className={cn("ml-auto", auth?.title === lookup.title ? "opacity-100" : "opacity-0")} />
                      </CommandItem>
                    ))}
                  </CommandGroup>
                </CommandList>
              </Command>
            </PopoverContent>
          </Popover>

          <div>
            <Label htmlFor="phone">{t("phone")}</Label>
            <Input id="phone" type="tel" onChange={(e) => setPhone(e.target.value)} />
          </div>
          <DialogFooter>
            <Button onClick={no}>{t("cancel")}</Button>
            <Button onClick={() => createUser()} variant="success">
              <Check />
              {t("save")}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default CreateUser;
